import * as React from "react";
import classnames from "classnames";
/* empty css              */
const LineItem = React.forwardRef(({ className, ...rest }, ref) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("elements-line-item", className), ref }));
LineItem.displayName = "LineItem";
export {
  LineItem as default
};
//# sourceMappingURL=LineItem.js.map
